export class Alert {
  id?: number;
  type: 'success' | 'error';
  text: string;
}
